<template>
  <v-row>
    <v-col lg="4" cols="12">
      <ProfileCard
        :user="authUser"
        v-bind:isProfile="true"
        v-bind:isDialog="completeProfile"
      />
      <v-card v-if="authUser.subscription_plan" class="mt-3 pa-4">
        <small class=""
          >You have been subscribed
          <b
            >${{ authUser.subscription_plan.price }} per
            {{ authUser.subscription_plan.interval }}</b
          >
          will expire on {{ lc_date() }}</small
        >
      </v-card>
    </v-col>
    <v-col lg="8" cols="12">
      <AboutYou />
      <div class="mt-4"></div>
      <v-card>
        <div class="pa-4">
          <div class="d-flex align-center">
            <b>Country</b>
            <small class="ml-auto">{{ authUser.country }}</small>
          </div>
          <div class="d-flex align-center">
            <b>City</b>
            <small class="ml-auto">{{ authUser.city }}</small>
          </div>
          <div class="d-flex align-center">
            <b>Sub Genre</b>
            <v-chip-group class="ml-auto">
              <v-chip
                v-for="(genre, k) of authUser.sub_genre"
                :key="k"
                x-small
                :class="{
                  'mr-0': k == authUser.sub_genre.length - 1,
                }"
                >{{ genre }}</v-chip
              >
            </v-chip-group>
          </div>

          <div class="d-flex align-center">
            <b>Skills</b>

            <v-chip-group class="ml-auto">
              <v-chip
                v-for="(instrument, k) of authUser.skills"
                :key="k"
                x-small
                :class="{
                  'mr-0': k == authUser.skills.length - 1,
                }"
                >{{ instrument }}</v-chip
              >
            </v-chip-group>
          </div>

          <div class="d-flex align-center">
            <b>Creating Since</b>
            <small class="ml-auto">{{ authUser.creating_since }}</small>
          </div>
          <div class="d-flex flex-wrap align-center">
            <b style="flex-shrink: 0" class="mr-4"
              >Performing Rights Organization</b
            >
            <v-chip-group class="ml-auto">
              <v-chip
                v-for="(pro, k) of authUser.performing_rights_organization"
                :key="k"
                x-small
                :class="{
                  'mr-0':
                    k == authUser.performing_rights_organization.length - 1,
                }"
                >{{ pro }}</v-chip
              >
            </v-chip-group>
          </div>
          <div class="d-flex align-center">
            <b>Label</b>
            <small class="ml-auto">{{ authUser.label }}</small>
          </div>
          <div class="d-flex align-center">
            <b>Sounds Like</b>
            <v-chip-group class="ml-auto">
              <v-chip
                v-for="(sound_like, k) of authUser.sounds_like"
                :key="k"
                x-small
                :class="{
                  'mr-0': k == authUser.sounds_like.length - 1,
                }"
                >{{ sound_like }}</v-chip
              >
            </v-chip-group>
          </div>
        </div>
      </v-card>
      <div class="mt-4"></div>
      <CreatorType :creator_type="authUser.creator_type" />
      <div class="mt-4"></div>
      <MusicVideos :videos="authUser.music_videos ? authUser.music_videos : []" />
      <div class="mt-4"></div>
      <MusicReference
        :references="authUser.streaming_links ? authUser.streaming_links : []"
      />
      <div class="mt-4"></div>
      <SocialCredits
        :audio="authUser.audio_references ? authUser.audio_references : []"
      />
      <div class="mt-4"></div>
      <SocialCreditsNews
        :audio="authUser.audio_references ? authUser.audio_references : []"
      />
      <div class="mt-4"></div>
      <SocialLinks
        :links="authUser.social_links ? authUser.social_links : []"
      />
      <div class="mt-4"></div>
    </v-col>
  </v-row>
</template>

<script>
import ProfileCard from "../components/ProfileCard.vue";
import CreatorType from "../components/profile/CreatorType.vue";
import MusicVideos from "../components/profile/MusicVideos.vue";
import MusicReference from "../components/profile/MusicReference.vue";
import AboutYou from "../components/profile/AboutYou.vue";
import SocialLinks from "../components/profile/SocialLinks.vue";
import SocialCredits from "../components/profile/SocialCredits.vue";
import SocialCreditsNews from "../components/profile/SocialCreditsNews.vue";
import moment from "moment";
export default {
  name: "Profile",
  data() {
    return {
      completeProfile: false,
    };
  },
  components: {
    ProfileCard,
    AboutYou,
    CreatorType,
    MusicVideos,
    MusicReference,
    SocialLinks,
    SocialCredits,
    SocialCreditsNews,
  },
  methods: {
    moment,
    lc_date() {
      return moment
        .unix(this.authUser.subscription_plan.expiry)
        .format("DD-MM-YYYY");
    },
  },
  beforeMount() {
    let completeProfile = this.$route.query.completeProfile;
    this.completeProfile = completeProfile === "true";
  },
  watch: {
    authUser() {
      this.completeProfile = !this.authUser.isCompleted;
    },
  },
};
</script>
